import axios from '../script/axiosAMS'

export default {
  getModemStop (params, resultCallback, errorCallback) {
    axios.requestWith({
      url: '/api/modem/stop',
      method: 'get',
      params: params,
      resultCallback: resultCallback,
      errorCallback: errorCallback
    })
  },
  modemStop (method, data, resultCallback) {
    axios.requestWith({
      url: '/api/modem/stop',
      method: method,
      data: data,
      resultCallback: resultCallback
    })
  },
  bulkInsertModemStop (data, resultCallback, errorCallback) {
    axios.requestWith({
      url: '/api/modem/stop',
      method: 'put',
      data: data,
      resultCallback: resultCallback,
      errorCallback: errorCallback
    })
  },
  setStep (data, resultCallback) {
    axios.requestWith({
      url: '/api/modem/stop/setStep',
      method: 'post',
      data: data,
      resultCallback: resultCallback
    })
  },
  stopDesc (params, resultCallback) {
    axios.requestWith({
      url: '/api/modem/stop/desc',
      method: 'get',
      params: params,
      resultCallback: resultCallback
    })
  }
}



// WEBPACK FOOTER //
// ./src/script/modemStop.js